import React from 'react';
import { Outlet } from 'react-router-dom';

import styles from './public-app.module.scss';
import { UserConfig } from 'app/models/user-config';
import { useQueryLanguage } from 'app/hooks/use-query-language';
import { config as appConfig } from 'app/config';
import { TopBar } from 'app/components/top-bar/top-bar';

interface Props {
  config: UserConfig | null;
}

export const PublicPage: React.FC<Props> = ({ config }) => {
  useQueryLanguage();

  return (
    <div className={styles.container}>
      <div className={styles.app}>
        {appConfig.showTopBar && (
          <header>
            <TopBar />
          </header>
        )}
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};
